import React from "react";
import styled from "styled-components";
import { CircularProgress } from "@material-ui/core";

const ScreenContainer = styled.div`
  width: 100%;
  height: 0;
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LoadingScreen = () => (
  <ScreenContainer>
    <CircularProgress />
  </ScreenContainer>
);

export default LoadingScreen;
